import {jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }
import {lazy} from 'react'
import {Redirect, Route, Switch, useLocation} from 'react-router'
import useAuthRoute from '../hooks/useAuthRoute'
import useNoIndex from '../hooks/useNoIndex'

const Graphql = lazy(
  () =>
    import(
      /* webpackChunkName: 'GraphqlContainer' */ '../modules/admin/containers/Graphql/GraphqlContainer'
    )
)
const Impersonate = lazy(
  () =>
    import(
      /* webpackChunkName: 'ImpersonateContainer' */ '../modules/admin/containers/Impersonate/ImpersonateContainer'
    )
)
const Signout = lazy(
  () => import(/* webpackChunkName: 'SignoutContainer' */ '../containers/Signout/SignoutContainer')
)
const NotFound = lazy(() => import(/* webpackChunkName: 'NotFound' */ './NotFound/NotFound'))
const DashboardRoot = lazy(() => import(/* webpackChunkName: 'DashboardRoot' */ './DashboardRoot'))
const MeetingRoot = lazy(() => import(/* webpackChunkName: 'MeetingRoot' */ './MeetingRoot'))
const MeetingSeriesRoot = lazy(
  () => import(/* webpackChunkName: 'MeetingSeriesRoot' */ './MeetingSeriesRoot')
)
const ViewerNotOnTeamRoot = lazy(
  () => import(/* webpackChunkName: 'ViewerNotOnTeamRoot' */ './ViewerNotOnTeamRoot')
)

const ActivityLibraryRoutes = lazy(
  () =>
    import(
      /* webpackChunkName: 'ActivityLibraryRoutes' */ './ActivityLibrary/ActivityLibraryRoutes'
    )
)

const ReviewRequestToJoinOrgRoot = lazy(
  () => import(/* webpackChunkName: 'ReviewRequestToJoinOrgRoot' */ './ReviewRequestToJoinOrgRoot')
)

const PrivateRoutes = () => {
  useAuthRoute()
  useNoIndex()
  const location = useLocation()
  const state = location.state
  return (
    _jsxs(_Fragment, { children: [
      _jsxs(Switch, { location: _optionalChain([state, 'optionalAccess', _ => _.backgroundLocation]) || location, children: [
        _jsx(Route, { path: "/activity-library", component: ActivityLibraryRoutes,} )
        , _jsx(Route, {
          path: "(/meetings|/me|/new-summary|/newteam|/team|/organization-join-request|/pages)",
          component: DashboardRoot,}
        )
        , _jsx(Route, { path: "/new-meeting", children: 
          _jsx(Redirect, { to: "/activity-library",} )
        })
        , _jsx(Route, { path: "/meet/:meetingId", component: MeetingRoot,} )
        , _jsx(Route, { path: "/meeting-series/:meetingId", component: MeetingSeriesRoot,} )
        , _jsx(Route, { path: "/admin/graphql", component: Graphql,} )
        , _jsx(Route, { path: "/admin/impersonate", component: Impersonate,} )
        , _jsx(Route, { path: "/invitation-required", component: ViewerNotOnTeamRoot,} )
        , _jsx(Route, { path: "/signout", component: Signout,} )
        , _jsx(Route, { component: NotFound,} )
      ]})
      , _jsx(Switch, { children: 
        _jsx(Route, {
          path: "/organization-join-request/:requestId",
          component: ReviewRequestToJoinOrgRoot,}
        )
      })
    ]})
  )
}

export default PrivateRoutes
